import qs from 'qs';
import axios from 'axios'
import lodash from 'lodash'

//const axiosFileUpload = axios.create({ headers: { "Content-Type": "multipart/form-data" } })

export default {
  install(vue, options) {
    //vue静态对象，非实例化的
    vue.prototype.$Vue = vue

    vue.prototype.$config = vue.config

    if (!vue.prototype.$lodash) vue.prototype.$lodash = lodash
    if (!vue.prototype.$axios) vue.prototype.$axios = axios

    if (!vue.prototype.$qs) vue.prototype.$qs = qs

    if (!vue.prototype.$message) vue.prototype.$message = function (msg) {
      console.log(msg)
    }

    /*
    $postObj
    Content-Type: 会根据data自动设置
    */
    if (!vue.prototype.$postObj) vue.prototype.$postObj = function (url, data, cfg, end) {
      var config = {}
      if (cfg) {
        if ((typeof cfg) == 'function') {
          config.transformRequest = [
            (_data, headers) => {
              cfg(_data, headers)
              return axios.defaults.transformRequest[0](_data, headers)
            }
          ]
          config.transformResponse = [
            (_data) => {
              end(_data)
              return axios.defaults.transformResponse[0](_data)
            }
          ]
          return axios.post(url, data, config);
        } else {
          return axios.post(url, data, cfg);
        }
      } else {
        return axios.post(url, data, config);
      }
    }



    /*
    注入$post
    默认Content-Type: application/x-www-form-urlencoded
    */
    if (!vue.prototype.$post) vue.prototype.$post = function (url, data, cfg, end) {

      return this.$postObj(url, qs.stringify(data), cfg, end)
    }

    if (!vue.prototype.$get) vue.prototype.$get = function (url) {
      return axios.get(url)
    }

    //注入$isFunction
    if (!vue.prototype.$isFunction) vue.prototype.$isFunction = function (obj) { return typeof obj === "function" && typeof obj.nodeType !== "number"; }

    //注入$isPlainObject
    if (!vue.prototype.$isPlainObject) vue.prototype.$isPlainObject = function (obj) {
      var proto, Ctor;

      // Detect obvious negatives
      // Use toString instead of jQuery.type to catch host objects
      if (!obj || toString.call(obj) !== "[object Object]") {
        return false;
      }

      proto = Object.getPrototypeOf(obj);

      // Objects with no prototype (e.g., `Object.create( null )`) are plain
      if (!proto) {
        return true;
      }

      var class2type = {};

      // Objects with prototype are plain iff they were constructed by a global Object function
      Ctor = class2type.hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor === "function" && class2type.hasOwnProperty.toString.call(Ctor) === class2type.hasOwnProperty.toString.call(Object);
    }

    //注入$extend
    if (!vue.prototype.$extend) vue.prototype.$extend = function () {
      var options, name, src, copy, copyIsArray, clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false;

      // Handle a deep copy situation
      if (typeof target === "boolean") {
        deep = target;

        // Skip the boolean and the target
        target = arguments[i] || {};
        i++;
      }

      // Handle case when target is a string or something (possible in deep copy)
      if (typeof target !== "object" && !this.$isFunction(target)) {
        target = {};
      }

      // Extend jQuery itself if only one argument is passed
      if (i === length) {
        target = this;
        i--;
      }

      for (; i < length; i++) {

        // Only deal with non-null/undefined values
        if ((options = arguments[i]) != null) {

          // Extend the base object
          for (name in options) {
            copy = options[name];

            // Prevent Object.prototype pollution
            // Prevent never-ending loop
            if (name === "__proto__" || target === copy) {
              continue;
            }

            // Recurse if we're merging plain objects or arrays
            if (deep && copy && (this.$isPlainObject(copy) ||
              (copyIsArray = Array.isArray(copy)))) {
              src = target[name];

              // Ensure proper type for the source value
              if (copyIsArray && !Array.isArray(src)) {
                clone = [];
              } else if (!copyIsArray && !this.$isPlainObject(src)) {
                clone = {};
              } else {
                clone = src;
              }
              copyIsArray = false;

              // Never move original objects, clone them
              target[name] = this.$extend(deep, clone, copy);

              // Don't bring in undefined values
            } else if (copy !== undefined) {
              target[name] = copy;
            }
          }
        }
      }

      // Return the modified object
      return target;
    }

    //注入$initFormItems
    if (!vue.prototype.$initFormItems) vue.prototype.$initFormItems = function (form, formItems, vset) {
      if (vset) {
        for (var i in formItems) {
          // console.log('$initFormItems'+i)
          if (form[formItems[i].prop] != formItems[i].value) {
            this.$set(form, formItems[i].prop, formItems[i].value);
          }

        }
      } else {
        for (var j in formItems) {
          if (form[formItems[j].prop] != formItems[j].value) {
            form[formItems[j].prop] = formItems[j].value;
          }

        }
      }
      return form
    }

    if (!vue.prototype.$setFormItems) vue.prototype.$setFormItems = function (value, formItems, vset) {
      if (vset) {
        for (var i in formItems) {
          // console.log('$setFormItems'+i)
          if (value[formItems[i].prop] != formItems[i].value) {
            this.$set(formItems[i], 'value', value[formItems[i].prop]);
          }

        }
      } else {
        for (var j in formItems) {
          if (formItems[j].value != value[formItems[j].prop]) {
            formItems[j].value = value[formItems[j].prop]
          }

        }
      }
    }

    //注入$ComparePatterns
    if (!vue.prototype.$ComparePatterns) vue.prototype.$ComparePatterns = {
      Ignore: 'Ignore',       /*忽略条件*/
      EQ: 'EQ',               /*相等*/
      LT: 'LT',               /*小于*/
      GT: 'GT',               /*大于*/
      Matchs: 'Matchs',       /*正则表达式（视接口数据库类型而定）*/
      Between: 'Between',     /*2个值之间的值*/
      NotNull: 'NotNull',     /*非null*/
      In: 'In',               /*一组范围中查找*/
      IsNull: 'IsNull',       /*是null*/
      Like: 'Like',           /*like模糊查找*/
      LE: 'LE',               /*小于或等于*/
      GE: 'GE',               /*大于或等于*/
      NotIn: 'NotIn',         /*不存在于*/
      Exists: 'Exists',       /*存在*/
      NotExists: 'NotExists'  /*不存在*/
    }



    /*
      注入$getComponent
      获取具体动态组件名称/对象
    */
    if (!vue.prototype.$getComponent) vue.prototype.$getComponent = function (comp, param) {
      if (typeof (comp) == 'function') return comp(param);
      return comp;
    }

    /*
      生成一个指定区间范围随机数(可以等于min和max)
    */
    if (!vue.prototype.$random) vue.prototype.$random = function (min, max) {
      return Math.floor(Math.random() * (max - min, + 1) + min,);
    }

    if (!vue.prototype.$getOptions) vue.prototype.$getOptions = function (prop) {
      var opts = []
      if (!this.$store) {
        return opts
      }
      var obj = this.$store.state[prop]
      if (obj) {
        for (var key in obj) {
          opts.push({
            value: key,
            label: obj[key]
          })
        }
      }
      return opts
    }

    if (!vue.prototype.$trim) vue.prototype.$trim = function (text) {
      return text == null ?
        '' :
        (text + '').replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }

    /*
      获取多级对象属性的值
      例如：var obj = { a: { b: 'bbb' } }
            this.$getPropValue(obj, 'a.b') => bbb
    */
    if (!vue.prototype.$getPropValue) vue.prototype.$getPropValue = function (obj, prop) {
      const segments = prop.split('.')
      for (let i = 0; i < segments.length; i++) {
        if (!obj) return
        obj = obj[segments[i]]
      }
      return obj
    }

    /*
      设置多级对象属性的值
    */
    if (!vue.prototype.$setPropValue) vue.prototype.$setPropValue = function (obj, prop, val) {
      const segments = prop.split('.')
      for (let i = 0; i < segments.length; i++) {
        if (!obj) return
        if (segments.length == (i + 1)) {
          obj[segments[i]] = val
        } else {
          obj = obj[segments[i]]
        }

      }
    }
  }
}
